/**
 * NatureNest Bestseller card enhancements
 * - Injects variant+price row (replaces default card-price)
 * - Injects CTA button
 * - Injects custom media badges from native Shopify badges
 *
 * Applied globally to all .nn-product-card sections
 */

(function () {
  var SECTION_SELECTOR = '.nn-product-card';
  var MAX_BADGES = 3;

  function titleCase(str) {
    return str.replace(/\w\S*/g, function (t) {
      return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
    });
  }

  function formatPrice(txt) {
    if (!txt) return '';
    var p = txt.trim();
    // Strip range prefixes that Shopify or the redesign price copy may add.
    p = p.replace(/^(Aus|From|ab)\s+/i, '').trim();
    p = p.replace(/CHF\s*/i, '').trim();
    p = p.replace(/^(Aus|From|ab)\s+/i, '').trim();
    p = p.replace(/\.00$/, '.\u2013');
    return 'ab CHF ' + p;
  }

  function formatComparePrice(txt) {
    if (!txt) return '';
    var p = txt.trim();
    p = p.replace(/^(Aus|From|ab)\s+/i, '').trim();
    p = p.replace(/CHF\s*/i, '').trim();
    p = p.replace(/^(Aus|From|ab)\s+/i, '').trim();
    p = p.replace(/\.00$/, '.\u2013');
    return 'CHF ' + p;
  }

  function getVariantName(card) {
    var name = '';

    // 1. Active swatch label
    var swatchLabel = card.querySelector('.swatch-label.is-active');
    if (swatchLabel) {
      name = swatchLabel.getAttribute('title') || '';
    }

    // 2. data-change-title element
    if (!name) {
      var changeTitleEl = card.querySelector('[data-change-title]');
      if (changeTitleEl) {
        name = changeTitleEl.textContent.replace(/^\s*-\s*/, '').trim();
      }
    }

    // 3. First swatch label
    if (!name) {
      var firstSwatch = card.querySelector('.swatch-label');
      if (firstSwatch) {
        name = firstSwatch.getAttribute('title') || '';
      }
    }

    // 4. Legend text in productView-options (color option value)
    if (!name) {
      var valueEl = card.querySelector('.productView-options .product-option-heading__value');
      if (valueEl) {
        name = valueEl.textContent.trim();
      }
      if (!name) {
        var legend = card.querySelector('.productView-options .form__label');
        if (legend) {
          var ft = legend.textContent.trim();
          var bEl = legend.querySelector('b');
          if (bEl) {
            name = ft.replace(bEl.textContent.trim(), '').trim();
          }
        }
      }
    }

    name = (name || '').trim();
    if (name.toLowerCase() === 'default title') return '';
    return titleCase(name);
  }

  function getPriceText(card) {
    var priceText = '';

    // 1. Regular (non-sale) price: present on single-variant products and products
    //    without a compare_at_price. This is the most reliable source.
    var regularEl = card.querySelector('.price__regular .price-item--regular');
    if (regularEl) {
      priceText = regularEl.textContent.trim();
    }

    // 2. Sale price (covers set products where price__regular is absent and the
    //    sale price element holds the actual displayed price, e.g. CHF 180.00).
    if (!priceText) {
      var salePriceEl = card.querySelector('.price-item--sale');
      if (salePriceEl) {
        priceText = salePriceEl.textContent.trim();
      }
    }

    // 3. Compare-at regular price (last resort; can be "CHF 0.00" when
    //    compare_at_price is not set, so skip zero values).
    if (!priceText) {
      var compareEl = card.querySelector('.price__compare .price-item--regular');
      if (compareEl) {
        var cTxt = compareEl.textContent.trim();
        // Ignore placeholder zeros ("CHF 0.00", "0.00", "0", etc.)
        if (cTxt && !/^(CHF\s*)?0(\.00)?$/.test(cTxt)) {
          priceText = cTxt;
        }
      }
    }

    // 4. Any price-item--regular as ultimate fallback
    if (!priceText) {
      var anyPrice = card.querySelector('.price-item--regular');
      if (anyPrice) {
        priceText = anyPrice.textContent.trim();
      }
    }

    return priceText;
  }

  function getComparePriceText(card) {
    var price = card.querySelector('.price.price--on-sale');
    if (!price) return '';

    var compareEl = price.querySelector('.price__compare .price-item--regular');
    if (!compareEl) return '';

    var compareText = compareEl.textContent.trim();
    if (!compareText || /^(CHF\s*)?0(\.00)?$/.test(compareText)) return '';

    return compareText;
  }

  function getBadgeModifier(nativeBadge) {
    if (!nativeBadge) return '';
    if (nativeBadge.classList.contains('new-badge')) return 'new';
    if (nativeBadge.classList.contains('sale-badge')) return 'sale';
    if (nativeBadge.classList.contains('sold-out-badge')) return 'sold-out';
    if (nativeBadge.classList.contains('custom-badge')) return 'custom';
    if (nativeBadge.classList.contains('bundle-badge')) return 'bundle';
    return '';
  }

  function init() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    section.querySelectorAll('.card-information__wrapper').forEach(function (wrapper) {
      var card = wrapper.closest('.card') || wrapper.closest('.product');
      if (!card) return;

      var titleEl = wrapper.querySelector('.card-title');
      if (!titleEl) return;

      // Inject CTA button
      if (!wrapper.querySelector('.nn-card-cta')) {
        var btn = document.createElement('a');
        btn.href = titleEl.getAttribute('href') || titleEl.href || '#';
        btn.className = 'nn-card-cta';
        btn.textContent = 'Zur Bettw\u00e4sche';
        wrapper.appendChild(btn);
      }

      // Inject variant + price row
      if (!wrapper.querySelector('.nn-variant-price-row')) {
        var variantName = getVariantName(card);
        var priceText = getPriceText(card);
        var compareText = getComparePriceText(card);

        var row = document.createElement('div');
        row.className = 'nn-variant-price-row';

        if (variantName) {
          var nameSpan = document.createElement('span');
          nameSpan.className = 'nn-variant-name';
          nameSpan.textContent = variantName;
          row.appendChild(nameSpan);
        }

        var priceGroup = document.createElement('span');
        priceGroup.className = 'nn-formatted-price-group';
        if (!variantName) priceGroup.style.marginLeft = 'auto';

        var priceSpan = document.createElement('span');
        priceSpan.className = 'nn-formatted-price';
        priceSpan.textContent = formatPrice(priceText);
        priceGroup.appendChild(priceSpan);

        if (compareText) {
          var compareSpan = document.createElement('span');
          compareSpan.className = 'nn-formatted-compare-price';
          compareSpan.textContent = formatComparePrice(compareText);
          priceGroup.appendChild(compareSpan);
        }

        row.appendChild(priceGroup);

        var cardPrice = wrapper.querySelector('.card-price');
        if (cardPrice) {
          wrapper.insertBefore(row, cardPrice);
        } else {
          var ctaBtn = wrapper.querySelector('.nn-card-cta');
          if (ctaBtn) {
            wrapper.insertBefore(row, ctaBtn);
          } else {
            wrapper.appendChild(row);
          }
        }
      }
    });

    // Inject media badges from native badge output (new/sale/custom/bundle/sold-out).
    section.querySelectorAll('.card-media').forEach(function (media) {
      var cardWrapper = media.closest('.card-product__wrapper');
      var existingContainer = media.querySelector('.nn-product-badges');
      if (existingContainer) existingContainer.remove();

      if (!cardWrapper) return;

      var nativeBadges = cardWrapper.querySelectorAll('.card__badge .badge');
      if (!nativeBadges.length) return;

      var badgesContainer = document.createElement('div');
      badgesContainer.className = 'nn-product-badges';
      var hasSaleBadge = false;

      Array.prototype.slice.call(nativeBadges, 0, MAX_BADGES).forEach(function (nativeBadge) {
        var text = (nativeBadge.textContent || '').trim();
        if (!text) return;

        var badge = document.createElement('span');
        var modifier = getBadgeModifier(nativeBadge);
        if (modifier === 'sale') hasSaleBadge = true;
        badge.className = modifier
          ? 'nn-product-badge nn-product-badge--' + modifier
          : 'nn-product-badge';
        badge.textContent = text;
        badgesContainer.appendChild(badge);
      });

      if (!badgesContainer.children.length) return;
      if (hasSaleBadge) badgesContainer.classList.add('nn-product-badges--has-sale');

      media.style.position = 'relative';
      media.appendChild(badgesContainer);
    });

    var productsFlex = section.querySelector('.products-flex');
    var existingScrollIndicator = section.querySelector('.nn-scroll-indicator');
    if (existingScrollIndicator) {
      existingScrollIndicator.remove();
    }

    // Inject dot indicators (one per product card)
    if (productsFlex && !section.querySelector('.nn-carousel-dots')) {
      var products = productsFlex.querySelectorAll('.product');
      if (products.length > 1) {
        var dotsContainer = document.createElement('div');
        dotsContainer.className = 'nn-carousel-dots';

        products.forEach(function (product, i) {
          var dot = document.createElement('button');
          dot.className = 'nn-carousel-dots__dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Produkt ' + (i + 1));
          dot.addEventListener('click', function () {
            productsFlex.scrollTo({
              left: product.offsetLeft,
              behavior: 'smooth'
            });
          });
          dotsContainer.appendChild(dot);
        });

        productsFlex.parentNode.insertBefore(dotsContainer, productsFlex.nextSibling);

        // Update active dot on scroll
        function getActivePageIndex() {
          var scrollLeft = productsFlex.scrollLeft;
          var activeIndex = 0;
          var smallestDelta = Infinity;

          products.forEach(function (product, index) {
            var delta = Math.abs(product.offsetLeft - scrollLeft);
            if (delta < smallestDelta) {
              smallestDelta = delta;
              activeIndex = index;
            }
          });

          return activeIndex;
        }

        function updateDots() {
          var activeIndex = getActivePageIndex();
          Array.prototype.forEach.call(dotsContainer.children, function (dot, i) {
            var isActive = i === activeIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'page' : 'false');
          });
        }

        productsFlex.addEventListener('scroll', updateDots);
        window.addEventListener('resize', updateDots);
        updateDots();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
